// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuItem_root__2UM8H"};